import './EmptyTodos.css';
const EmptyTodos = () => {
    return <p>Create your first TODO</p>;
}

export default EmptyTodos;